import { render, staticRenderFns } from "./AdminFooter.vue?vue&type=template&id=7b889dac&scoped=true"
import script from "./AdminFooter.vue?vue&type=script&lang=js"
export * from "./AdminFooter.vue?vue&type=script&lang=js"
import style0 from "./AdminFooter.vue?vue&type=style&index=0&id=7b889dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b889dac",
  null
  
)

export default component.exports